import { useFormik } from "formik";
import {
  Button,
  Col,
  Form,
  Row,
  Card,
  Modal
} from "react-bootstrap";
import { useState } from "react";
import { toast } from "react-toastify";
import {
  FaTwitter,
  FaFacebook,
  FaLinkedin,
  FaOrcid,
  FaBoxTissue,
  FaAt,
  FaTrash,
  FaUserAlt
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";

import * as api from "../../../api/authors"

const CreateAuthor = ({ menu, update, author }) => {
  let initialValues;
  let navigate = useNavigate();
  const [preview, setPreview] = useState("http://via.placeholder.com/300x400");
  const [showModal, setShowModal] = useState(false);

  if (update) {
    initialValues = { ...author };
  } else {
    initialValues = {
      gender: "unselected",
      _id:null,
      birth_date: "",
      description:"",
      university: "",
      facebook: "https://www.facebook.com/",
      twitter: "https://www.twitter.com/",
      linkedin: "https://www.linkedin.com/in/",
      orcid: "https://orcid.org/my-orcid?orcid=",
      cvlac:"https://scienti.minciencias.gov.co/cvlac/visualizador/generarCurriculoCv.do?cod_rh=",
      homepage: "",
    };
  }
  const formik = useFormik({
    initialValues,
    onSubmit: async (values) => {
        // console.log("formik >>>>>", values)
        if (update) {
            api.updateAuthor(values._id, values).then(res=>{
                // formik.resetForm();
                // console.log("update >>>>>>> ", res);
                toast.success(`¡El autor ha sido actualizado!`,{
                    position: toast.POSITION.TOP_RIGHT,
                    className: "foo-bar",
                });
            }).catch(err=>{
                console.log(">>>>>>> ", err);
                toast.warning("Ha fallado la creación del usuario!",{
                  position: toast.POSITION.TOP_RIGHT,
                  autoClose: 4000,
                  pauseOnHover: false,
                });
            })
        }else{
            api.createAuthor(values).then(res=>{
                // formik.resetForm();
                console.log(">>>>>>> ", res);
                toast.success(`¡El autor ha sido creado!`,{
                    position: toast.POSITION.TOP_RIGHT,
                    className: "foo-bar",
                });
            }).catch(err=>{
                console.log(">>>>>>> ", err);
                toast.warning("Ha fallado la creación del usuario!",{
                  position: toast.POSITION.TOP_RIGHT,
                  autoClose: 4000,
                  pauseOnHover: false,
                });
            })
        }      
    },
  });

  function previewImage(e) {
    setPreview(URL.createObjectURL(e.target.files[0]));
  }

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);
  const handleConfirm = () => {
    api.deleteAuthor(author._id).then(res=>{
        // formik.resetForm();
        console.log(">>>>>>> ", res);
        navigate("/editorial/authors");
        toast.success(`¡El autor ha sido eliminado!`,{
            position: toast.POSITION.TOP_RIGHT,
            className: "foo-bar",
            autoClose: 4000,
            pauseOnHover: false,
        });
        
    }).catch(err=>{
        console.log(">>>>>>> ", err);
        toast.warning("Ha fallado la creación del usuario!",{
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 4000,
          pauseOnHover: false,
        });
    })
  }

  return (
    <>
        {update ? (
            <Modal show={showModal} onHide={handleClose}>
                <Modal.Header closeButton>
                <Modal.Title>Confirma eliminación</Modal.Title>
                </Modal.Header>
                <Modal.Body>Desea eliminar el autor {author.firstName} {author.lastName}</Modal.Body>
                <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Cancelar
                </Button>
                <Button variant="primary" onClick={handleConfirm}>
                    Continuar
                </Button>
                </Modal.Footer>
            </Modal>):null
        }
        <Form encType="multipart/form-data" onSubmit={formik.handleSubmit}>
          <Card style={{ width: "100%", padding: "10px" }}>
            <Card.Body>
              <input type="hidden" name="id" id="id" value={formik.values._id}/>
              <Row>
                <Col sm={9} md={9}>
                    <Row>
                      <Col>
                        <Form.Group controlId="firstName">
                          <Form.Label>Nombres (*)</Form.Label>
                          <Form.Control
                            defaultValue={formik.values.firstName}
                            onChange={formik.handleChange}
                            placeholder=""
                            required
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group controlId="lastName">
                          <Form.Label>Apellidos(*) </Form.Label>
                          <Form.Control
                            defaultValue={formik.values.lastName}
                            onChange={formik.handleChange}
                            placeholder=""
                            required
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Form.Group controlId="email">
                        <Form.Label>Correo público del autor</Form.Label>
                        <Form.Control
                          defaultValue={formik.values.email}
                          onChange={formik.handleChange}
                          type="email"
                          style={{ width: "100%" }}
                        />
                      </Form.Group>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group controlId="birthDate">
                          <Form.Label>Fecha de nacimiento</Form.Label>
                          <Form.Control
                            defaultValue={formik.values.birthDate.slice(0, 10)}
                            onChange={formik.handleChange}
                            type="date"
                            placeholder="Password"
                          />
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group controlId="hometown">
                          <Form.Label>Lugar de nacimiento</Form.Label>
                          <Form.Control
                            defaultValue={formik.values.hometown}
                            onChange={formik.handleChange}
                            placeholder="Pais, Departamento, Ciudad"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Form.Group controlId="university">
                        <Form.Label>Autoría/filiación</Form.Label>
                        <Form.Control
                          defaultValue={formik.values.university}
                          onChange={formik.handleChange}
                          placeholder="Ej: Universidad del Valle"
                          required                          
                        />
                      </Form.Group>
                    </Row>
                    <Row>
                      <Form.Group controlId="description" className="mb-3">
                        <Form.Label>Descripción</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={3}
                          defaultValue={formik.values.description}
                          onChange={formik.handleChange}
                        />
                      </Form.Group>
                    </Row>
                    <Row>
                        <Form.Group controlId="gender" className="mb-3">
                            <Form.Label>Sexo</Form.Label>
                            <Form.Select
                                onChange={formik.handleChange}
                                defaultValue={formik.values.gender}
                            >
                                <option value="unselected">No definido</option>
                                <option value="female">Femenino</option>
                                <option value="male">Masculino</option>
                                <option value="nobinary">No binario</option>
                            </Form.Select>
                        </Form.Group>
                    </Row>
                    <Row>
                      <Form.Group controlId="facebook">
                        <div className="input-group mb-3">
                          <span className="input-group-text">
                            <FaFacebook />
                          </span>
                          <Form.Control
                            defaultValue={formik.values.facebook}
                            onChange={formik.handleChange}
                            type="text"
                            placeholder="Perfil de facebook"
                          />
                        </div>
                      </Form.Group>
                      <Form.Group controlId="twitter">
                        <div className="input-group mb-3">
                          <span className="input-group-text">
                            <FaTwitter />
                          </span>
                          <Form.Control
                            defaultValue={formik.values.twitter}
                            onChange={formik.handleChange}
                            type="text"
                            placeholder="Perfil de facebook"
                          />
                        </div>
                      </Form.Group>

                      <Form.Group controlId="linkedin">
                        <div className="input-group mb-3">
                          <span className="input-group-text">
                            <FaLinkedin />
                          </span>
                          <Form.Control
                            defaultValue={formik.values.linkedin}
                            onChange={formik.handleChange}
                            type="text"
                            placeholder="Perfil de linkein"
                          />
                        </div>
                      </Form.Group>

                      <Form.Group controlId="orcid">
                        <div className="input-group mb-3">
                          <span className="input-group-text">
                            <FaOrcid />
                          </span>
                          <Form.Control
                            defaultValue={formik.values.orcid}
                            onChange={formik.handleChange}
                            type="text"
                            placeholder="Perfil de ORCID"
                          />
                        </div>
                      </Form.Group>

                      <Form.Group controlId="cvlac">
                        <div className="input-group mb-3">
                          <span className="input-group-text">
                            <FaBoxTissue />
                          </span>
                          <Form.Control
                            defaultValue={formik.values.cvlac}
                            onChange={formik.handleChange}
                            type="text"
                            placeholder="Perfil de CVLAC"
                          />
                        </div>
                      </Form.Group>

                      <Form.Group controlId="homepage">
                        <div className="input-group mb-3">
                          <span className="input-group-text">
                            <FaAt />
                          </span>
                          <Form.Control
                            defaultValue={formik.values.homepage}
                            onChange={formik.handleChange}
                            type="text"
                            placeholder="Página principal del autor"
                          />
                        </div>
                      </Form.Group>
                    </Row>
                    <Row>
                      {update ? (
                        <>
                             <Col sm={8} md={8}>
                                <Button variant="primary" type="submit" style={{width:"100%"}}>
                                    <FaUserAlt size={20}/> Actualizar
                                </Button>
                            </Col>
                            <Col sm={4} md={4}>
                            <Button variant="secondary" onClick={handleShow} style={{width:"100%"}}>
                                <FaTrash size={20}/> Eliminar
                            </Button>
                            </Col>
                        </>
                      ) : (
                        <Col sm={12} md={12}>
                            <Button variant="primary" type="submit" style={{width:"100%"}}>
                                <FaUserAlt size={20}/> Crear
                            </Button>
                        </Col>
                      )}
                    </Row>
                </Col>
                <Col sm={3} md={3}>
                  <img
                    width="100%"
                    className="img-thumbnail"
                    src={preview}
                    alt="author-pic"
                    style={{ maxHeight:"200px", minHeight:"200px" }}
                  />
                  <Form.Control
                    onChange={previewImage}
                    type="file"
                    accept="image/*"
                    placeholder="Imagen"
                  />
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Form>
    </>
  );
};

export default CreateAuthor;
